import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
export var lightSpeedIn = {
  easing: 'ease-out',
  0: {
    opacity: 0,
    translateX: 200,
    skewX: '-30deg'
  },
  0.6: {
    opacity: 1,
    translateX: 0,
    skewX: '20deg'
  },
  0.8: {
    skewX: '-5deg'
  },
  1: {
    opacity: 1,
    translateX: 0,
    skewX: '0deg'
  }
};

if (typeof lightSpeedIn !== 'undefined' && lightSpeedIn && lightSpeedIn === Object(lightSpeedIn) && Object.isExtensible(lightSpeedIn) && !lightSpeedIn.hasOwnProperty('__filemeta')) {
  Object.defineProperty(lightSpeedIn, '__filemeta', {
    configurable: true,
    value: {
      name: "lightSpeedIn",
      filename: "node_modules/react-native-animatable/definitions/lightspeed.js"
    }
  });
}

export var lightSpeedOut = {
  easing: 'ease-in',
  0: {
    opacity: 1,
    translateX: 0,
    skewX: '0deg'
  },
  1: {
    opacity: 0,
    translateX: 200,
    skewX: '30deg'
  }
};

if (typeof lightSpeedOut !== 'undefined' && lightSpeedOut && lightSpeedOut === Object(lightSpeedOut) && Object.isExtensible(lightSpeedOut) && !lightSpeedOut.hasOwnProperty('__filemeta')) {
  Object.defineProperty(lightSpeedOut, '__filemeta', {
    configurable: true,
    value: {
      name: "lightSpeedOut",
      filename: "node_modules/react-native-animatable/definitions/lightspeed.js"
    }
  });
}